module.exports = __webpack_public_path__ + "static/media/18ECA5.6d1cf72c.jpg";